var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{attrs:{"fluid":""}},[_c('v-tabs',{attrs:{"centered":""}},_vm._l((_vm.shownTabs),function(tab,index){return _c('v-tab',{key:index,attrs:{"to":{ name: tab.target }}},[_vm._v(" "+_vm._s(tab.name)+" ")])}),1),_c('router-view',{staticClass:"mt-8"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }